"use client"
import CWFSheet from "@/components/ui/CWFSheet";

export default function CWFResponsiveSheet({ children,trigger,open,onOpenChange, className,...props }) {

    return (
        <CWFSheet
            open={open}
            onOpenChange={onOpenChange}
            className={className}
            trigger={trigger}
            {...props}
        >
            {children}
        </CWFSheet>
    )
}